import { steps } from "@/mocks/kanliao";

export default function Guide() {
  return (
    <section id="guide" className="bg-background-100/70 py-16 md:py-24">
      <div className="container-px">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div className="max-w-xl">
            <span className="section-title">订阅方式</span>
            <h2 className="heading mt-4">三步开通，之后交给提醒</h2>
            <p className="prose-p mt-4">
              从选择到确认只需一分钟，订阅开通后无需再手动刷新，新料动态会自己找上门。
            </p>
          </div>
          <div className="hidden items-center gap-2 text-sm text-foreground-600 md:flex">
            <i className="ri-time-line text-primary-600" aria-hidden="true"></i>
            平均开通时间不足 60 秒
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
          {steps.map((step, index) => (
            <article
              key={step.no}
              className="relative rounded-2xl border border-background-200/70 bg-background-50 p-7"
            >
              <div className="flex items-center justify-between">
                <span className="font-heading text-5xl font-black text-primary-200">
                  {step.no}
                </span>
                <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-accent-500 text-background-50">
                  <i className={`${step.icon} text-2xl`} aria-hidden="true"></i>
                </span>
              </div>
              <h3 className="mt-5 font-heading text-xl font-bold text-foreground-950">
                {step.title}
              </h3>
              <p className="mt-3 text-sm leading-7 text-foreground-600">
                {step.desc}
              </p>
              {index < steps.length - 1 && (
                <i
                  className="ri-arrow-right-line absolute top-1/2 -right-5 hidden text-2xl text-primary-300 md:block"
                  aria-hidden="true"
                ></i>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}